import React from 'react';
import { FormErrorMessage } from 'src/shared/design-system/Input/Error/FormErrorMessage';
import { LabeledTextInput } from 'src/shared/design-system/Input/LabeledTextInput/LabeledTextInput';
import styled from 'styled-components';
import { Spacing } from 'web-common/src/shared/styles';
import { AppleLogin } from '../oAuth/AppleLogin';
import { GoogleLoginV3 } from '../oAuth/GoogleLoginV3';
import { AuthActionButton } from './AuthActionButton';
import { AuthType, EntryFormProps, useLoginOrSignUpEntryForm } from './useLoginOrSignUpEntryForm';

const ErrorMessageWithMargin = styled(FormErrorMessage)`
  margin-top: -${Spacing.HALF};
`;

interface LogInOrSignUpModalEntryFormProps extends EntryFormProps {
  formCloseButton: JSX.Element | null;
}

export const LogInOrSignUpModalEntryForm: React.FC<LogInOrSignUpModalEntryFormProps> = (props) => {
  const { email, onEmailChange, continueCTA, formCloseButton } = props;
  const { error, emailError, loading, handleEmailContinue, handleKeyDown, showApple, googleProps, appleProps } =
    useLoginOrSignUpEntryForm(props);

  return (
    <div className='flex flex-col gap-4'>
      <GoogleLoginV3 {...googleProps} />
      {error && error.type === AuthType.GOOGLE ? (
        <ErrorMessageWithMargin>{error.errorMessage}</ErrorMessageWithMargin>
      ) : null}

      {showApple ? (
        <>
          <AppleLogin {...appleProps} />
          {error && error.type === AuthType.APPLE ? (
            <ErrorMessageWithMargin>{error.errorMessage}</ErrorMessageWithMargin>
          ) : null}
        </>
      ) : null}
      <div className='text-center text-base font-semibold leading-5'> Or </div>
      <form onSubmit={handleEmailContinue} onKeyDown={handleKeyDown}>
        <fieldset className='flex flex-col items-center gap-4' disabled={loading}>
          <LabeledTextInput
            label='Email'
            name='email'
            value={email}
            onChange={onEmailChange}
            errorMessage={emailError}
            data-cy='login-entry-email'
          />
          {error && error.type === AuthType.EMAIL ? (
            <ErrorMessageWithMargin>{error.errorMessage}</ErrorMessageWithMargin>
          ) : null}
          <AuthActionButton value={continueCTA ?? 'Continue'} disabled={loading} data-cy='login-entry-continue' />
          {formCloseButton}
        </fieldset>
      </form>
    </div>
  );
};
